<template>
<div></div>
</template>

<script>
export default {
  name: "Page"
}
</script>

<style scoped>

</style>